const whitelistedSwids = [
    '{AEDB5BCC-173D-49BD-9B0B-77DFD5964C19}', // rob wong
    '{CAF029A0-42FD-4A72-A3B4-225A523BB6F8}', // alex murp
    '{41806771-14BA-4372-8067-7114BA137205}', // paul ferrug
    '{83557C90-D1C1-48E5-BD25-C180CF1A843C}', // takashi aoki
    '{3D4B6DA0-89C1-4061-93BE-4DF366407219}', // mike andrews
    '{64BFB324-993C-11D2-94D2-00A0C9E596A0}', // aaron laberge
    '{DC6D6CAB-31D6-47A9-B570-E388A23E82DE}', // john racz
    '{340CE85D-75A3-4266-B2EA-20442C0C9DCB}', // jesse pringle
    '{83CA9BE6-3078-460B-9104-BD7F202524E6}'  // mike kidd
];

export default function isSwidInWhitelist(swid) {
    if (swid) {
        return (whitelistedSwids.indexOf(swid) !== -1);
    }
    return false;
}



// WEBPACK FOOTER //
// ./app/lib/whitelist/index.js